import { render } from "./PropertyDetails.vue?vue&type=template&id=3932b387"
import script from "./PropertyDetails.vue?vue&type=script&lang=js"
export * from "./PropertyDetails.vue?vue&type=script&lang=js"

import "./PropertyDetails.vue?vue&type=style&index=0&id=3932b387&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__